var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-privacy-joychat",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Privacy Policy")]),
      _c("span", [_vm._v("Effective: Feb.1.2024")]),
      _c("div", { staticClass: "tit" }, [_vm._v("1. Introduction")]),
      _c("div", [
        _vm._v(
          ' This is the Privacy Policy of Liangziqianxun Technology or one of its affiliates ("we" or "JoyChat"), a company with its registered address at Wuhan, ("JoyChat", "App", "us", "we", or "our") which is incorporated into and is subject to our Terms of Use. Please read on to learn more about our data handling practices. Please ensure that you fully understand the terms of this Privacy Policy and agree with this Privacy Policy before accessing or using our JoyChat mobile application ("App"), www.joyme.chat ("Site") or all of the services available or related to therein (collectively referred to in this Privacy Policy as the "Service"). If you do not agree with the terms of this Privacy Policy, please do not use the Service. '
        ),
      ]),
      _c("div", [
        _vm._v(
          " When you use our Services, we may collect data from you as described below. When you register and use your account with us we will collect data from you in order to provide the Services. The types of data we collect depends on how you use our Services. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("2. What information we collect"),
      ]),
      _c("div", [
        _vm._v(
          " When you use our Services, for example, visit and use our Site or App, install the App on your device, or register for an account with the App, some personally identifiable information about you is collected in order for us to be able to provide you with the Services. Further details about this are set out below. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.1. Registration and account data"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " When you install the Service on your device and/or register for an account with the App, personally and/or non-personally identifiable information about you may be collected. There are two types of Registration and Account Data; data: "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Information you provide (mandatory) - You will be asked to provide your gender, name or an alias and date of birth together with your mobile phone. This is necessary to enable us provide you with the connection and friends features in our Service. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Information you provide (optional) - You may also choose to provide other personally identifiable information such as your photos or videos of yourself, description of yourself and information about your interests. The provision of such information is entirely optional. If you register and log in using your Facebook, Google account or your mobile phone, you allow us to collect additional information that you make available to us. For example, if you register with the App using your Facebook account (e.g., Facebook Connect), we may collect and store your Facebook ID and corresponding token on our servers for automatic log in and profile information and, if you give us your express consent, we will have access to and may collect certain information that you make available on Facebook (for example, your first and last names, email address, profile picture, birthdays). We will store it on our servers and use it to facilitate your use of the Service – for example - we may synchronize your App account between different devices which you may use to access our Service. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We also use your contact information to market to you as your country’s laws allow – for example if there are new offerings for our Services or updates regarding changes to our Services and to help others find your account if your settings permit, including through third-party services and client applications. You can use your settings for email and mobile notifications to control notifications you receive from us. You can also unsubscribe from a notification by following the instructions contained within the notification. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.2. Registration and account data"),
      ]),
      _c("div", [
        _vm._v(
          " When you use our Services we may collect information about your location. With your explicit consent, we may also collect information about your precise location using methods that include GPS, wireless networks, cell towers, Wi-Fi access points, and other sensors, such as gyroscopes, accelerometers, and compasses. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("2.3. Log Information")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          'We receive information when you view content on or otherwise interact with our Services, which we refer to as "Log Data".'
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " For example, when you visit our Site, sign into our Services, interact with our email notifications, use your account to authenticate to a third-party service, we may receive information about you. This Log Data includes information such as your IP address, browser type, operating system, configuration information made available by the App or desktop browser, the referring web page, pages visited, location, your mobile carrier, device information (including device and application IDs), search terms (including those not submitted as queries), and cookie information. We also receive Log Data when you click on, view, or interact with links or make connections on our Services and general information about your communications on the App such as the user you have communicated with and the date and duration of your communications (but not the content of such communications, unless required for safety and security reasons) including when and if you install another application through our Services. We use Log Data to operate our Services and ensure their secure, reliable, and robust performance. The purpose for using Log Data is to protect the security of accounts and to determine what is popular on our services and importantly Log Data is used to enable you to make connection with new and former connections on the App. We also use this data to improve our Services. We also use metadata, which means information related to items to you have made available through the App, such as the date or location that you made a connection via the App. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.4. Data from Corporate Group and other third parties"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We may receive information about you from Corporate Group, third parties such as partners who help us evaluate the safety and quality of content on our platform, and other services you link to your account. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We use the information we receive to operate our Services. For integrations that we formally support, you may revoke this permission at any time from your application settings; for other integrations, please visit the other service you have connected. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You may provide us with payment information, including your credit or debit card number, card expiration date, CVV code, and billing address, in order to make purchases provided as part of our Services. If you make a payment or send money using our features or Services, including through an intermediary, we may receive information about your transaction such as when it was made. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " If another user uploads their contact list, we may combine information from that user’s contact list with other information we have collected about you. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.5. Data from browsers or devices"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " When you log into the App on a browser or device, we will associate that browser or device with your account for purposes such as authentication, security, and personalization. Subject to your settings, we may also associate your account with browsers or devices other than those you use to log into the App (or associate your logged-out device or browser with other browsers or devices). When you provide other information to the App, including an email address, we associate that information with your App account. Subject to your settings, we may also use this information in order to infer other information about your identity, for example by associating your account with hashes of email addresses that share common components with the email address you have provided to the App. We do this to operate and personalize our Services. For example, if you log in through Facebook, we may connect with your age profile there to help maintain the required standards to be on our App and use the Services. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.6. Data collected during usage of the App"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Device information - The App may collect and store information about the device(s) which you use to install and access the App, such as your device model, unique device identifier, IP address, device capability and statistics on page views. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Your activity - The App may collect and store information about your and others’ usage of and activity within the App and our Site, including matches, numbers of matches made by members, match durations, text messaging, music choices made when using the App, usage of messaging service and usage of location service. We require from your device access to use and to copy your photos for your profile picture and any photos/ media files you choose to share, so they can be reproduced in the App and on our Site. We require the ability to access your camera / microphone and to record video/ audio for us to deliver the video and audio, including music files and related files in order for you to use and enjoy the Services whilst using the App and our Site and also to help us with our compliance requirements, such as ensuring under 18s are not permitted to use our App or our Site. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Content you shared - The App allows you to share your profile, interests, text messages, photos, screenshots, videos, music and other communications in the App with other users, and if you choose to do so, your in-App profile, interests, text messages, photos, screenshots, videos, music choices and other communications will be stored on our servers. In addition, if you choose to share these items with other App users, we may not be able to remove them from our servers or make them unavailable to anyone you have shared them with. By choosing to share such information, you agree that you may no longer be able to control how that information is used and that it may become publicly available (depending in part on your actions or the actions of the other users with whom you have shared the information). The App shall not be responsible for any use or misuse of such information that you share with other users. You may refer to Part 7 below for more information on the parties with whom you may choose to share your content. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' Content you created - We may also collect and store any user content (e.g. photos, screenshots, comments, interests and other materials) that you create or post on the App ("User Content"). '
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Information about transactions made through our Service - In order to complete a transaction, you will be requested to provide your payment information, which includes your credit card number, card expiration date, CVV code, and billing address. In that event, we will transmit your information securely directly to a third-party vendor or merchant who will collect such information in order to process and fulfil your purchase. The App may process or store your payment information. However, we may store other information about your purchases made on the App, which may include the merchant’s name, the date, time and amount of the transaction and other behavioural information such as your purchase history. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Error-reporting information - We also collect error-reporting information if the App crashes or fails to operate properly so that we can investigate the error and improve the stability of the App for future releases. In general these reports do not contain personally identifiable information, or only incidentally. These error reports contain information such as the type and version of your device, the device identifier, the time the error occurred, the feature being used and the state of the App when the error occurred. We do not use this information for any purpose other than investigating and fixing the error. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("2.7. Data collected when you visit our Site"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We may use online tracking technology such as cookies, pixel tags, web beacons and other similar technologies to automatically collect information about: "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· your visits to our Site, such as your browsing history, how long you stay on our Site, and how often you visit; and"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · your location information as provided by your mobile or other device when you interact with our Site, including your IP address and general geographic location; and the device that you use to browse our Site (e.g. your device ID, operating system, type of device, browser type and version, mobile application crashes and other system activity, and third party sites you were using before interacting with our Services). "
        ),
      ]),
      _c("div", [
        _vm._v(
          ' You have the right to disable any of these online tracking technologies. These help us ensure you are able to log into your account securely, develop our Services by using data analytics and develop new services for our users. To learn more about how we use the above data, please see the "Cookie Policy" section below. '
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("2.8. Age")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " The Service is not directed at children or persons under the age of eighteen (18) and we do not knowingly collect personally identifiable information from children or persons under the age of eighteen (18) as part of the Service. We do however collect information regarding your age to ensure underage users are not part of our Services in order to maintain the security of our Services and use third parties to help us maintain the correct age profile for our App. If we become aware that we have inadvertently received or collected personally identifiable information from a user under the age of eighteen (18) as part of the Service, we will delete such information from our records. If you are under the age of eighteen (18), please do not use the Service. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("2.9 Facial data")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Facial date, such as when you use some features provided by us to create special effects or emojis for your streaming section or pictures that you uploaded on Services, but such data will only be processed offline to fulfill the special effects or emojis and we will not use it for other purposes unless we have obtained your explicit consent or turn this into de-identified data; further, we will not use your facial data for marketing or advertising, nor will we share such data with any third party. In addition, if you utilize Real-Person Profile Picture Authentication, we collect your profile picture and facial-recognition video for Real-Person Profile Picture Authentication on the premise of your approval by comparing your profile picture with face-recognition video. This authentication can protect you from impersonators and fake accounts, or develop the authenticity of Services. We do not retain your face recognition video in our servers, such video is merely for verifying. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("3. Your User Profile")]),
      _c("div", [
        _vm._v(
          ' You can access, control and modify the information you provide for your user profile on the App (your "Profile") at anytime. This includes your profile and profile pictures and videos, name, interests, personal bio, languages you speak and your birthday, all of which can be shared with your App contacts. So please ensure you only share what you want to include in your Profile. Your Profile will be made available to other users of the App who are connected to you. In addition, your Profile is discoverable by other App users, for example, through listing of App contacts in the App that will include your proximity to other users. '
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' You may also choose to "block" any other App user in your contact list in the App which will prevent them from discovering your Profile at any time. In addition, we may pre-populate your Profile with certain information such as your name and Facebook profile picture, date of birth, email, gender, Facebook ID if you have logged into your account on the App using your Facebook account. You can delete and change your Profile information in the App as indicated below in section 12. '
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("4. Purpose and Use of Personal Data"),
      ]),
      _c("div", [
        _vm._v(
          " We adopt the data minimization principle when collecting and using your data and ensure that your data will only be used in accordance with the stated purposes below. We will only process your data in connection with the Service and for other related business purposes, including: "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("4.1 To provide you with the Service, including:"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v("· to connect you with other users within the App;"),
      ]),
      _c("div", [
        _vm._v(
          "· to enable you to share your Profile with other users on the App;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· to provide you with video and audio call functions of the App;"
        ),
      ]),
      _c("div", [
        _vm._v("· to allow you to send images and videos through the App;"),
      ]),
      _c("div", [
        _vm._v(
          "· to show you the names of persons you communicate with and to show your name to persons you communicate with on the App; and"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · to provide you with certain features of the App that may be offered from time to time, such as our Premium Services (please see our Terms of Use),play games and share /play music during your video calls. "
        ),
      ]),
      _c("div", [_vm._v("· to enable you to contact us")]),
      _c("div", [
        _vm._v("· to connect with third parties for payment processing"),
      ]),
      _c("div", [
        _vm._v(
          " · to run analytics to provide you with better and relevant connections, provide you with additional offers and for the purpose of providing you with updates to our Services. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v(
          "4.2 To help us administer and maintain your account and user Profile on the App, including:"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v("· creating and updating your account;"),
      ]),
      _c("div", [
        _vm._v(
          "· delivering to you any administrative notices, alerts and communications relevant to your use of the App."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· to facilitate networking opportunities through the Service and provide you with location or interests information relating to other users of the App."
        ),
      ]),
      _c("div", [
        _vm._v(
          " · to use the information we have to develop, test and improve our Services, including by conducting surveys, compiling research, statistics and analytics as well as habits and behaviours of users such as purchase history, online interactions, and testing and troubleshooting new products and features. "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· to handle and process any payments for transactions carried out through the Service via third party service providers."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· to communicate with you about our Services, and let you know about our policies and terms."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· to also use your information to respond to you when you contact us."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· sharing with third parties and the Corporate Group (see below in section 6) in order to meet our contractual obligations."
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("4.3 Promote safety, integrity and security."),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " · For audit, compliance, controls, security and other risk management purposes, we use the information we have to verify accounts and activity, combat harmful conduct, detect and prevent other bad experiences, illegal behaviour, maintain the integrity of our Services, and promote safety and security. For example, we use a combination of automated detection technology and manual review of the data we have to investigate suspicious activity or violations of our Terms of Use and policies such as this Privacy Policy and enable you to report and contact us if you have any issues to raise. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v(
          "4.4 For business management purposes, including data and record management:"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v("· To establish, exercise and/or defend our legal rights."),
      ]),
      _c("div", [
        _vm._v(
          "· To comply with our legal, regulatory and reporting requirements to regulatory bodies."
        ),
      ]),
      _c("div", [
        _vm._v("· To ensure the safety of users through content moderation."),
      ]),
      _c("div", [
        _vm._v(
          " · In connection with a corporate transaction involving the App, such as the purchase or sale of a business unit, an acquisition, merger, sale of assets, or another similar event. "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· To enable us to provide the Services and our contractual commitments to you."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· To enable us to carry out our contractual obligations with our Corporate Group and third parties."
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("4.5 To connect information across our Services:"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " · We connect information about you and your activities on the App with our other Apps and Services provided by us to provide you with a broad engagement experience and to provide a more tailored and consistent experience with your use of the Services. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("4.6 For analytical purposes:"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " · We may also pseudonymise or aggregate your personal data for analytical purposes. This helps us develop new and improve existing Services, conduct fraud detection and account safety analysis, analyse usage trends, and provide third party service providers with basic statistics about how their service is being used by the App users. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("5. Legal Basis for Processing Your Data"),
      ]),
      _c("div", [
        _vm._v(
          " There are different legal reasons for processing your data while you are using our Service. With respect to these legal reasons, we process your data for one or more of the following basis. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("5.1 With your explicit consent"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We will not process your personal data without your explicit consent. We will only process your personal data when you have given us consent to process your personal data for specified purposes, such as to provide our Service and other items requested by you. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("5.2 Without your explicit consent"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Notwithstanding the foregoing, please note that your personal data may be processed without seeking your explicit consent in cases where one or more of the following conditions is met: "
        ),
      ]),
      _c("div", [_vm._v("· It is expressly provided for by the laws;")]),
      _c("div", [
        _vm._v(
          " · It is necessary for the protection of life or physical integrity of you or of any other person, who is unable to explain his/her consent due to the physical disability or whose consent is not deemed legally valid; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · Processing of your personal data is necessary and directly related to the establishment or performance of the contract between you and the App (i.e., Terms of Use); "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· It is necessary for compliance with a legal obligation to which the App is subject;"
        ),
      ]),
      _c("div", [
        _vm._v("· Your personal data has been made public by yourself;"),
      ]),
      _c("div", [
        _vm._v(
          "· Processing of your personal data is necessary for the establishment, exercise or protection of any right;"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · Processing of your personal data is necessary for the legitimate interests pursued by the App, provided that this processing shall not violate your fundamental rights and freedoms. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("6. Sharing with Third Parties"),
      ]),
      _c("div", [
        _vm._v(
          " We may provide your personal data to the Corporate Group, vendors and service providers who support our business, such as by providing technical infrastructure services, analysing how our Services are used, providing customer service, security services, facilitating payments, music sharing or conducting surveys with your explicit consent, unless one or more of the conditions as set out in section 5.2 are met. Besides, if we share your personal data abroad, we will ensure adequate protection is provided or provide commitment for adequate protection in writing and obtain authorisation of the applicable authority. Examples of third parties to whom your personal data may be disclosed or transferred to for any of the purposes mentioned in this Privacy Policy in order for the Services to be provided to you are: "
        ),
      ]),
      _c("div", [
        _vm._v(
          ' ·Our parent company, subsidiaries, affiliates and/or branch offices (collectively referred to in this Privacy Policy as the "Corporate Group") who support the App or Site Services as well as the integration of your information with our other apps who deliver and perform the Services; '
        ),
      ]),
      _c("div", [
        _vm._v(
          " ·Any of our or any Corporate Group member’s agents, contractors including, IT companies who support our website and other business systems, back office service providers, payment service providers, data management and analytics service providers, and data cleansing service providers; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " ·Any relevant third parties such as telecommunications operators, third party collection agencies, credit reference agencies, security agencies (including identification verification service providers), credit providers, banks, financial institutions (including any payment processors); ·Any professional advisors (including our legal advisors and auditors); "
        ),
      ]),
      _c("div", [
        _vm._v(
          "·Any regulatory authorities, law enforcement, courts and other governmental agencies;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "·And any of our actual or proposed assignees or transferees of any part of our business or operations."
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v(
          "7. Parties with whom you may choose to share your User Content"
        ),
      ]),
      _c("div", [
        _vm._v(
          " Any information or content that you voluntarily disclose or post on the App, such as your User Content, becomes available to the public. Once you have shared such User Content or made it public, that User Content may be viewed and re-shared by others and it may not be possible to prevent the distribution of that User Content once it becomes public. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Even if you remove any User Content (e.g. screenshots, etc.) that you created or posted on the App, copies of such User Content may remain accessible in the cached and archived pages of the App, or if other users or third parties have copied or saved such information.(e.g. from using Facebook, etc.) "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Any personally identifiable information that you: (i) share in text messages, photos, videos or otherwise in or through the App with other users; or (ii) submit via live messaging on the App, can be viewed and used by others. Iwee is not responsible for any use or misuse of such information that you share or submit. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("8. Data Access and Removal")]),
      _c("div", [
        _vm._v(
          " You can always control what information you choose to share with us on the App (except for information which we have indicated as mandatory for you to provide). To do so, you can change your settings in the App or in your mobile device. Alternatively, you can remove the App from your mobile device entirely. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You can choose to remove your data anytime you want. If you ask us to delete your account, we will use commercially reasonable efforts to remove your data from our servers, subject to any applicable legal or other requirement to maintain certain records of your personally identifiable data. Please note that the deletion of your personally identifiable data from our database may result in us not being able to provide you with the Service. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' You can delete your account within the App. The path to delete your account: find "Me" > then select "Setting" > then choose "Account Settings" > then click on "Delete Account". '
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("9. Security")]),
      _c("div", [
        _vm._v(
          " Protecting your privacy and personal data is a top priority for us. We protect the privacy and security of all personally identifiable information you provide to us. We run stress tests on our systems to help us improve. Access to all personally identifiable information is strictly restricted to the App and Corporate Group employees, contractors, agents and Third-Party Partners and service providers who need to know that information in order to provide, operate, develop, maintain, support or improve the Service or otherwise carry out any of the purposes as set out in this Privacy Policy. The App implements appropriate technical and physical security measures, such as using password protection, access logs, and system monitoring to maintain the confidentiality and security of all users’ information against any loss or unauthorised disclosure, use and modification. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " However, due to the inherent nature of the Internet and related technology, we do not guarantee the protection of information under our control against any loss, misuse or alteration. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' Your personal data may be stored and processed in any country in which the App or Corporate Group or their service providers maintain facilities. In this regard, or for purposes of sharing or disclosing data as described in this Privacy Policy, the App reserves the right to transfer your personal data outside your country. The App and the Corporate Group share infrastructure, systems and technology to provide an innovative, relevant, consistent and safe experiences across all of the Corporate Group Apps, such as the App you use. We also process information about you across the Corporate Group for these purposes, as permitted by applicable law and in accordance with their terms and policies. When we transfer personal data internationally, we put in place safeguards in accordance with applicable law. If you would like to know more about our personal data transfer practices, please contact us at the contact details set out under the "Contact Information" section. We may also pseudonymise or aggregate Personal Information for analytical purposes. This helps us develop new and improve existing services, conduct fraud detection and account safety analysis, analyse usage trends, and provide third party service providers with basic statistics about how their service is being used by our users. '
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("10. Retention of Your Data")]),
      _c("div", [
        _vm._v(
          " We will keep your personal data only for so long as is necessary to fulfil the purposes outlined in this Privacy Policy, unless the law requires us to keep it for a longer period. Once we no longer need your personal data, we will either irreversibly anonymise or securely delete it from our servers. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("11. Your Data Protection Rights"),
      ]),
      _c("div", [
        _vm._v(
          "The App would like to make sure you are fully aware of all of your data protection rights. In particular, you are entitled to the following rights:"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(1) to learn whether your personal data are processed by the App or not,"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(2) to demand for information as to if your personal data have been processed by the App,"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(3) to learn the purpose of the processing of your personal data and whether these personal data are used in compliance with the purpose,"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(4) to know the third parties to whom your personal data are transferred by the App abroad,"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' (5) to request the rectification of the incomplete or inaccurate data, if any. For example, if you entered incorrect age or gender, we can assist you. Please submit a report at www.joyme.chat or contact us at details set out under "Contact Information" section and we will handle your request, '
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " (6) to request the erasure or destruction of your personal data in the event that the reasons for the processing no longer exist or as required by law, "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " (7) to request reporting of the operations carried out pursuant to sub-paragraphs (5) and (6) above to third parties to whom your personal data have been transferred by the App, "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(8) to object to the occurrence of a result against you by analyzing the data processed solely through automated systems,"
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "(9) to claim compensation for the damage arising from the unlawful processing of your personal data."
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("12. Exercising Your Data Protection Rights"),
      ]),
      _c("div", [
        _vm._v(
          " If you wish to update or delete your personal data submitted, you can update or delete it via the App. Alternatively, you can send your request to our Customer Service Manager at: joychat9527@gmail.com "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' In addition, you have the right to lodge complaints about how the App manages your personal data. You can lodge a complaint with the App whose contact details are set out under the "Contact Information" section below, or with a local data protection regulator. '
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We will conclude demands in your request within the shortest time by taking into account the nature of the demand and at the latest within thirty (30) days and free of charge. However if the action requires an extra cost, fees may be charged in the tariff determined by applicable authority. If we refuse your request, we will communicate and explain our response to you together with justified grounds. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("13. Cookie Policy")]),
      _c("div", [
        _vm._v(
          "Cookies are small text files that are stored on your browser or device by websites, applications, online media and advertisements when you visit a website."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We use cookies and other similar identification technologies such as web beacons and pixel tags on our Site, App, emails and online advertisements for various purposes, including verifying users; remembering user preferences and settings to enhance your experience when you return to our Site or App; delivering relevant content and advertisements based on your preferences, location and usage patterns; monitoring, evaluating and optimising the operation of our Site and App; tracking and measuring the effectiveness of our advertising campaigns; and analysing traffic on our Site, our App and the websites of our partners or Corporate Group members. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You can exercise your right to choose whether or not to accept cookies by adjusting your browser settings to modify your cookie preferences. Most browsers are set to accept cookies by default or prompt you to accept cookies, but you are free to remove or block all browser cookies. However, if you turn off your cookies, some of our services may not function properly and you will not be able to receive the most efficient and personalised experience. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("14. Notification of Changes"),
      ]),
      _c("div", [
        _vm._v(
          " We reserve the right at our discretion to make changes to this Privacy Policy from time to time. You may review updates to our Privacy Policy at any time via links on our Site. You agree to accept electronic communications and/or postings of a revised Privacy Policy on the Site, and you agree that such electronic communications or postings constitute notice to you of the Privacy Policy. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " If we make material changes to this Privacy Policy, we will notify you by publishing a revised Privacy Policy or by means of a notice on our Site, or as a pop up within our App, or as required by law. You agree to review the Privacy Policy periodically so that you are aware of any modifications. You agree that your continued use of the Service after we publish a revised Privacy Policy or provide a notice on our website constitutes your acceptance of the revised Privacy Policy. If you do not agree with the terms of revised Privacy Policy, you must stop your access or use of our Services. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("15. Contact Information")]),
      _c("div", [
        _vm._v(
          "If you have any questions about this Privacy Policy, please contact our us by email : joychat9527@gmail.com"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }